import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const CloseIcon = (props: SvgIconProps) => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill={"none"} {...props}>
    <path
      d="M8.91992 7.99999L13.3199 3.59999C13.6399 3.27999 13.6399 2.79999 13.3199 2.47999C12.9999 2.15999 12.5199 2.15999 12.1999 2.47999L7.79992 6.87999L3.39992 2.47999C3.07992 2.15999 2.59992 2.15999 2.27992 2.47999C1.95992 2.79999 1.95992 3.27999 2.27992 3.59999L6.67992 7.99999L2.27992 12.4C1.95992 12.72 1.95992 13.2 2.27992 13.52C2.43992 13.68 2.63992 13.76 2.83992 13.76C3.03992 13.76 3.23992 13.68 3.39992 13.52L7.79992 9.11999L12.1999 13.52C12.3599 13.68 12.5599 13.76 12.7599 13.76C12.9599 13.76 13.1599 13.68 13.3199 13.52C13.6399 13.2 13.6399 12.72 13.3199 12.4L8.91992 7.99999Z"
      fill={props.fill ? props.fill : "#333333"}
    />
  </SvgIcon>
);

export default CloseIcon;
